// ⚠️ 本文件由 scripts/prepare-project.ts 按 project-config themes 清单生成，请勿手工修改。
// mode=ecom；入包主题：m；默认主题：m
import type { ThemeDefinition } from './index';
import theme_m from './m';

/** 当前构建入包主题（仅这些主题的代码会进包，模式隔离核心） */
export const themeRegistry: Record<string, ThemeDefinition> = {
  m: theme_m,
};

/** 当前构建默认主题 */
export const defaultTheme = 'm';
